var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.route.storeonlineorderreport") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{ pageName, list: ['LIST'] }",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.retailerId"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerId },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "retailerId", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.retailerName"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "retailerName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.orderNo"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.orderNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "orderNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.tireOrderNo"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.tireOrderNo },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "tireOrderNo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.orderCreateTime"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "startDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.orderCreateTimeStart,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.startPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "orderCreateTimeStart",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "endDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.orderCreateTimeEnd,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.endPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "orderCreateTimeEnd",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: {
                        label: _vm.$t(
                          "sfe.storeonlineorderreport.input.finishedTime"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "startDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.finishedTimeStart,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.finishedStartPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "finishedTimeStart",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "endDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.finishedTimeEnd,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.finishedEndPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "finishedTimeEnd",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: _vm.$t("sfe.storeonlineorderreport.orderNo"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderSkuQty",
                  label: _vm.$t("sfe.storeonlineorderreport.orderSkuQty"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderScanInQty",
                  label: _vm.$t("sfe.storeonlineorderreport.orderScanInQty"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scopeItem) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scopeItem.row.tireOrderNo
                                ? scopeItem.row.orderScanInQty
                                : "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "warrantyScanOutQty",
                  label: _vm.$t(
                    "sfe.storeonlineorderreport.warrantyScanOutQty"
                  ),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scopeItem) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scopeItem.row.tireOrderNo
                                ? scopeItem.row.warrantyScanOutQty
                                : "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderLabel",
                  label: _vm.$t("sfe.storeonlineorderreport.orderLabel"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCreateTime",
                  label: _vm.$t("sfe.storeonlineorderreport.orderCreateTime"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "finishedTime",
                  label: _vm.$t("sfe.storeonlineorderreport.finishedTime"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireOrderNo",
                  label: _vm.$t("sfe.storeonlineorderreport.tireOrderNo"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerId",
                  label: _vm.$t("sfe.storeonlineorderreport.retailerId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerName",
                  label: _vm.$t("sfe.storeonlineorderreport.retailerName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }